import { FC, memo } from 'react';
import classnames from 'classnames';

import { Currencies, PricePlanRowPureType } from 'domain/api/graphql/generated';

import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';
import AccordionList from '@zvuk-b2b/react-uikit/ui/Accordion/AccordionList';

import { TEXTS } from './texts';
import useRatesTableViewModel from './useRatesTableViewModel';
import { RatesList } from './RatesLIst';

import styles from './index.module.scss';

interface RatesTableRows {
  className?: string;
  pricePlanTitle: string;
  pricePlanCurrency: Currencies;
  periodPayFrequencyMonth: number;
  rows: PricePlanRowPureType[];
  elementIdPrefix?: string;
  pricePlanOpenedInMobile?: boolean;
}

const RatesTable: FC<RatesTableRows> = ({
  periodPayFrequencyMonth,
  pricePlanTitle,
  pricePlanCurrency,
  rows,
  className,
  elementIdPrefix = 'current_price_plan',
  pricePlanOpenedInMobile = false,
}) => {
  const { isMobile } = useMedia();

  const { isChangePricePlanAvailable, isPrimeDiscountAvailable, primeDiscountValue } = useRatesTableViewModel();

  return (
    <div className={styles.container}>
      <div
        className={classnames(styles.ratesTable, className)}
        data-top-space={!isChangePricePlanAvailable}>
        {isMobile ? (
          <AccordionList
            elementId="accordion_rates_list"
            data={[
              {
                id: 1,
                title: <div className={styles.title}>{TEXTS.RATES_TABLE_PRICES_TITLE(pricePlanTitle)}</div>,
                description: (
                  <RatesList
                    elementIdPrefix={elementIdPrefix}
                    isPrimeDiscountAvailable={isPrimeDiscountAvailable}
                    rows={rows}
                    primeDiscountValue={primeDiscountValue}
                    pricePlanCurrency={pricePlanCurrency}
                    periodPayFrequencyMonth={periodPayFrequencyMonth}
                  />
                ),
              },
            ]}
            openedIndex={pricePlanOpenedInMobile ? 0 : 1}
            containerClassName={styles.accordionContainer}
            itemClassName={styles.accordionItem}
            itemTitleClassName={styles.accordionItemTitle}
            itemDescriptionClassName={styles.accordionItemDescription}
            itemDescriptionHiddenClassName={styles.accordionItemDescriptionHidden}
            openIconPlacement="right"
          />
        ) : (
          <>
            <div className={styles.title}>{TEXTS.RATES_TABLE_PRICES_TITLE(pricePlanTitle)}</div>

            <RatesList
              elementIdPrefix={elementIdPrefix}
              isPrimeDiscountAvailable={isPrimeDiscountAvailable}
              rows={rows}
              primeDiscountValue={primeDiscountValue}
              pricePlanCurrency={pricePlanCurrency}
              periodPayFrequencyMonth={periodPayFrequencyMonth}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default memo(RatesTable);
